import { combineReducers } from '@reduxjs/toolkit';
import { reducer as footer } from './footer';
import { reducer as video } from './video';

export const reducer = combineReducers({
  footer,
  video,
});
